import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const zScoreDescription: CalculatorDescription = {
  id: CalculatorId.Z_SCORE,
  title: 'Z-score calculator',
  metaTitle: 'Z-Score Calculator - Standardize Data Values',
  description: 'Calculate z-scores to standardize your data and determine how many standard deviations a value is from the mean.',
  metaDescription: 'Free online z-score calculator. Standardize data values and determine their position relative to the mean in standard deviation units.',
  howTo: {
    title: 'How to calculate z-scores',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Reference data column" control to select which column of data to analyze',
      'Enter a specific value in the "Value to find z-score for" field',
      'The calculator will automatically compute the z-score for your entered value',
      'View the visualization to see where your value falls in the distribution'
    ],
    graphic: {
      description: 'Visual representation of z-score calculation'
    }
  },
  examples: [
    {
      title: 'Standardizing test scores',
      description: 'Converting raw test scores to standardized z-scores',
      dataDescription: 'Test scores from a class of students',
      insights: [
        'Positive z-scores indicate values above the mean',
        'Negative z-scores indicate values below the mean',
        'Z-scores allow comparison across different datasets',
        'About 68% of values fall between z-scores of -1 and 1'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['65', '72', '78', '80', '82', '85', '88', '90', '92', '95'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN,
    CalculatorId.NORMAL_DISTRIBUTION
  ]
}; 